<template>
  <div>
      <div class="columns">
        <div class="column is-9">
          <player-report></player-report>
        </div>
        <div class="column">
          <div class="small-segment">
            <player-table heading="Cardiff Devils" :tableData="clean" :headings="['#','']" redirect="/season-stats/player-stats/"></player-table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import PlayerReport from './player-report.vue'
import playerTable from '../playerTable.vue'
import _ from 'lodash'
export default {
  components: {
    'player-report': PlayerReport,
    'player-table': playerTable
  },
  data: function () {
    return {
      Players: [],
      Team: []
    }
  },
  computed: {
    clean () {
      let cleanData = []
      _.map(this.Players, function (object) {
        if (object.number > 0) {
          cleanData.push(_.pick(object, ['id', 'number', 'name']))
        }
      })
      cleanData = _.orderBy(cleanData, 'number', ['asc'])
     // cleanData = _.orderBy(cleanData, 'number', ['asc'])
      return cleanData
    }
  },
  methods: {
    fetchPlayers () {
      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + 1, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Players = response.data
        console.log(this.Players)
      }, response => {
      })
    },
    fetchTeam () {
      this.$http.get('https://devilsapi.roblutken.com/api/teams/get/' + 1, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Team = response.data
        console.log(JSON.stringify(this.Team))
      }, response => {
      })
    },
    openReport (id) {
      this.$router.push('/season-stats/player-stats/' + id)
    }
  },
  created: function () {
    this.fetchPlayers()
  }
}
</script>

<style>
.small-segment{
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 100%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// player-season-stats.vue?3f341fb6